<template>
  <div class="help-form warp">
    <div>
      <a-form :form="form" @submit="handleSubmit">
        <a-row :gutter="[24, 16]">
          <a-col :xl="19" :xs="18">
            <a-form-item>
              <a-cascader
                size="large"
                :options="optionsData"
                placeholder="请选择行业"
                v-decorator="['commodity']"
                popupClassName="ab-pro-market-cascader"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item>
              <div>
                <a-select
                  size="large"
                  v-decorator="[
                    'industry',
                    // {
                    //   rules: [{ required: true, message: '请选择行业!' }],
                    // },
                  ]"
                  placeholder="请选择行业"
                >
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option
                    v-for="d in industryOptionsData"
                    :key="d.code"
                  >
                    {{ d.cname }}
                  </a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-select
                show-search
                :value="value"
                placeholder="请选择类目别名"
                :filter-option="false"
                :not-found-content="null"
                @search="handleCommoditySearch"
                size="large"
                v-decorator="['commodity']"
              >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option
                  v-for="d in commodityOptionsData"
                  :key="d.commodity.code"
                >
                  {{ d.commodity.cname }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="7">
            <a-form-item>
              <a-range-picker
                size="large"
                format="YYYY-MM-DD"
                :placeholder="['请选择询盘开始日期', '询盘截至日期']"
                v-decorator="['range-picker']"
                @change="onChange"
                @ok="onOk"
              />
            </a-form-item>
          </a-col> -->
          <a-col :xs="6" :xl="5">
            <a-button size="large" type="primary" html-type="submit"> 搜索 </a-button>
            <a-button
              size="large"
              class="resetBtn"
              type="primary"
              :style="{
                marginLeft: '17px',
                backgroundColor: 'transparent',
                color: '#2B68FF',
              }"
              @click="handleReset"
            >
              重置
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        v-if="!errorMsgStatus"
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="inquiryData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="contactInfo" slot-scope="text, record">
          <p
            v-show="record.contactPerson && record.contactPerson.email"
            class="item-contact"
          >
            <i class="iconfont icon-youxiang"></i
            ><span>{{
              record.contactPerson && record.contactPerson.email
                ? record.contactPerson.email
                : ""
            }}</span>
          </p>
          <p
            v-show="record.contactPerson && record.contactPerson.tel"
            class="item-contact"
          >
            <i class="iconfont icon-dianhua"></i
            ><span>{{
              record.contactPerson && record.contactPerson.tel
                ? record.contactPerson.tel
                : ""
            }}</span>
          </p>
          <p
            v-show="record.contactPerson && record.contactPerson.phone"
            class="item-contact"
          >
            <i class="iconfont icon-shouji"></i
            ><span>{{
              record.contactPerson && record.contactPerson.phone
                ? record.contactPerson.phone
                : ""
            }}</span>
          </p>
        </template>
        <span
          slot="action"
          class="action-words fontSize18"
          slot-scope="text, record"
          @click="showModal(record)"
        >
          查看详情
        </span>
      </a-table>
      <div v-else style="height: 100%">
        <ab-error-vue :imgHidden="true"></ab-error-vue>
      </div>
    </div>
    <inquiry-detail-modal-vue
      :visible="visible"
      :detailRecord="detailRecord"
      @cancel="handleCancel"
    ></inquiry-detail-modal-vue>
  </div>
</template>

<script>
import moment from "moment";
// import 'moment/locale/zh-cn';
import { industryList, commodityList, inquiryList, categoryList } from "@/api/inquiry";
import InquiryDetailModalVue from "./InquiryDetailModal.vue";
import AbErrorVue from "@/components/AbError.vue";
const columns = [
  {
    title: "最新询盘内容",
    dataIndex: "demand",
    // sorter: true,
    width: "20%",
    ellipsis: true,
    // scopedSlots: { customRender: 'name' },
  },
  {
    title: "相关行业",
    dataIndex: "industry",
    width: "15%",
    ellipsis: true,
    customRender: (industry, row, index) => {
      console.log(industry, "---------customRender------");
      if (industry instanceof Array) {
        let industryArr = [];
        industry.forEach((element, index) => {
          let showText = "";
          if (element.cname) {
            showText = element.cname;
            if (
              row["product"] instanceof Array &&
              row["product"][index] &&
              row["product"][index]["alias"]
            ) {
              showText += element.cname + "/" + row["product"][index]["alias"];
            }
          }
          industryArr.push(showText);
        });
        return industryArr.join(",");
      }

      return "";
    },
  },
  {
    title: "联系人",
    dataIndex: "contactPerson",
    customRender: (contactPerson, row, index) => {
      return contactPerson && contactPerson.name ? contactPerson.name : "";
    },
  },
  {
    title: "联系方式",
    dataIndex: "contactInfo",
    width: "20%",
    ellipsis: true,
    scopedSlots: { customRender: "contactInfo" },
  },
  {
    title: "来源国家",
    dataIndex: "country",
    customRender: (country, row, index) => {
      if (country instanceof Array) {
        let dataArr = [];
        country.forEach((element) => {
          element.cname && dataArr.push(element.cname);
        });
        return dataArr.join(",");
      }

      return "";
    },
  },
  {
    title: "询盘时间",
    dataIndex: "time",
    customRender: (time, row, index) => {
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  {
    title: "操作",
    width: "8%",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  components: {
    InquiryDetailModalVue,
    AbErrorVue,
  },
  data() {
    return {
      errorMsgStatus: false,
      expand: false,
      visible: false,
      defaultRequest: true,
      form: this.$form.createForm(this, { name: "advanced_search" }),
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        // showTotal: 'total => ``',
        showTotal: (total) => `共计${total}条`,
      },
      loading: false,
      columns,
      optionsData: [],
      industryOptionsData: [],
      commodityOptionsData: [],
      inquiryData: [],
      filterParams: {},
      detailRecord: {},
    };
  },
  mounted() {
    this.fetchInquiryList();
    this.fetchCategoryList();
    // this.fetchIndustryList();
    // this.fetchCommodityList();
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        this.defaultRequest = false;
        console.log("Received values of form: ", values);
        let params = {};
        // if (values['industry']) {
        //   params['industry'] = [values['industry']];
        // }

        if (values["commodity"]) {
          params["industry"] = [values["commodity"][0]];
          params["commodity"] = [values["commodity"][1]];
        }
        this.filterParams = params;
        this.fetchInquiryList(params);
      });
    },
    onChange(value, dateString) {
      console.log("Selected Time: ", value);
      console.log("Formatted Selected Time: ", dateString);
    },
    onOk(value) {
      console.log("onOk: ", value);
    },
    handleReset() {
      this.form.resetFields();
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetchInquiryList({
        // results: pagination.pageSize,
        // page: pagination.current,
        // sortField: sorter.field,
        // sortOrder: sorter.order,
        // ...filters,
      });
    },

    handleCommoditySearch(value) {
      this.fetchCommodityList({
        keyword: value,
      });
    },

    async fetchCategoryList() {
      const optionsData = await categoryList();
      this.optionsData = optionsData;
      console.log("optionsData=====", optionsData);
    },

    fetchIndustryList() {
      industryList({ level: 1, type: "INDUSTRY" }).then(({ data }) => {
        this.industryOptionsData = data;
      });
    },
    fetchCommodityList(params = {}) {
      commodityList({ keyword: "a", ...params }).then(({ data }) => {
        this.commodityOptionsData = data && data["list"] ? data["list"] : [];
      });
    },
    fetchInquiryList(params = {}) {
      this.loading = true;
      let param = {
        ...this.filterParams,
        ...params,
        defaultRequest: this.defaultRequest,
        pages: {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize,
        },
      };
      inquiryList(param).then(({ code, data }) => {
        // console.log(data, '=======data========');
        // if (!data) {
        //   this.loading = false;
        //   this.inquiryData = [];
        //   const pagination = { ...this.pagination };
        //   pagination.total = 0;
        //   this.pagination = pagination;
        // }

        if (code === 3007001) {
          this.errorMsgStatus = true;
          this.loading = false;
          // this.modalTitle = '搜索提示';
          return;
        }
        const inquiryData = data && data["list"] ? data["list"] : [];
        const pages = data.pages;
        // console.log(inquiryData, '=======inquiryList========');
        const pagination = { ...this.pagination };
        pagination.total = pages.totalCount || 0;
        // pagination.showTotal = 'total => `Total ${pagination.total} items`';
        this.inquiryData = inquiryData;
        this.pagination = pagination;
        this.loading = false;
      });
    },

    showModal(record) {
      this.visible = true;
      this.detailRecord = record || {};
      console.log(record, this.visible, "-----------");
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>

.help-form{
  ::v-deep .ant-table-tbody > tr:last-child > td{
    border:none;
  }
  ::v-deep .ant-table-tbody > tr > td{
    font-size:18px
  }
  .action-words{
    color: rgba(43, 104, 255, 1);
    font-family: AlibabaPuHuiTiM;
    text-align: left;
    white-space: nowrap;
    cursor: pointer;
  }

  .item-contact{
    margin-bottom:0px;
  .icon-shouji{
    font-size:24px;
        position: relative;
    left: 5px;
    color:#000
  }
  .icon-youxiang{
      font-size:36px;
      position: relative;margin-right: -9px;
      left:-2px;
      color:#000
  }
  .icon-dianhua{
      font-size:28px;
      color:#000
  }
    display: flex;
    align-items: center;
  }
  .item-contact > span{
    padding-left: 10px;
    font-size:14px;
  }

  ::v-deep .ant-pagination-total-text{
    float: right;
    padding-left: 5px;
  }
  ::v-deep .ant-table table{
    border-radius: 20px;
    border: 1px solid #D6EAFF;
    overflow: hidden
  }
  ::v-deep .ant-table-thead > tr > th{
    height: 80px;
    background: #F4F9FF;font-size: 18px;
  }
  ::v-deep .ant-col-5{
    text-align:right;
  }

  ::v-deep .ant-btn-primary{
    height:50px;font-family: 'Alibaba-PuHuiTi-R';
    width:117px;
    padding:0px;
    font-size: 18px;
    border-radius: 8px;
  }
  ::v-deep .ant-calendar-picker-clear{
        border-radius: 50%;
    overflow: hidden;
  }
  ::v-deep .ant-calendar-range-picker-separator{
    margin-top: 7px;
  }
  ::v-deep .ant-select-lg .ant-select-selection__rendered {
    line-height: 50px;margin-left: 30px;
  }
  ::v-deep .ant-calendar-range-picker-input::placeholder,.ant-select-arrow .ant-select-arrow-icon,.ant-select-selection__placeholder, .ant-select-search__field__placeholder{
    color:#333;font-family: 'Alibaba-PuHuiTi-R';
  }
  ::v-deep .ant-select-selection,.ant-calendar-picker-input.ant-input{
    border:none;
    background:rgba(216,216,216,0.4);
    border-radius: 8px;
    height:50px;
  }
::v-deep .ant-cascader-picker-label{
  font-size:16px;
  text-indent: 20px;
}

  ::v-deep .ant-cascader-input.ant-input{
    border:none;
    background:#f5f5f5 !important;text-indent: 20px;
    border-radius: 8px;
    height:50px;
  }
  padding-top: 60px;
  padding-bottom: 38px;
}
</style>
